import React from 'react'
import AndroidPushCard from './AndroidPushCard'
import IosPushCard from './IosPushCard'
import type { PreviewContent, PreviewPlatform } from './types'

export interface PushNotificationCardProps {
  content: PreviewContent
  platform: PreviewPlatform
  // The merchant's uploaded logo; falls back to the brand-red placeholder
  // square when omitted (no logo uploaded).
  appIconUrl?: string
}

// Push-notification preview — a thin platform dispatcher mirroring the sibling
// per-platform split (LiveActivityCard, IosLockScreen/AndroidLockScreen). iOS
// renders a translucent lock-screen banner (IosPushCard); Android a Material
// collapsed notification (AndroidPushCard). The {location_name} token renders
// literally in both.
const PushNotificationCard = ({
  content,
  platform,
  appIconUrl,
}: PushNotificationCardProps) => {
  const platformProps = { content, appIconUrl }
  return platform === 'ios' ? (
    <IosPushCard {...platformProps} />
  ) : (
    <AndroidPushCard {...platformProps} />
  )
}

export default PushNotificationCard
